// extracted by mini-css-extract-plugin
export default {"CategoryBlock":"style_CategoryBlock__mR0QW","CategoryBlock__error":"style_CategoryBlock__error__ZSGsg","dataContainer":"style_dataContainer__co8Xm"};